// lib/world/sceneConfig.js
// Shared world configuration so the simulation and renderer agree.
// Use plain arrays here to keep this module engine-agnostic (no Yuka/Three imports).

import { MODEL_POIS } from './modelPois.js'

export const WORLD = {
  // Visual floor size (square)
  floorSize: 250,
  // Simulation bounds radius (used for soft bounds + periphery targets)
  boundsRadius: 145,
}

export const SHRINES = {
  // Kept in sync with the 'shrine' POI (poi_15) so the Cat shrine model sits
  // on its glowing floor circle. The first-person spawn is set back from it.
  // At the middle of the square, where Kiwi_world.blend has the statue: its
  // collider (Cube.358 in obstacles.glb, x -3.92 to 4.01, z -7.55 to 3.02)
  // was built round a cat here, and the market props are laid out round it.
  // On 13 July this became -8.43 (the blend's marker is at y -8.44 there,
  // which is z +8.44 here, out in front of the cat), which put the cat in the
  // ruins' steps, half out of its own box, its disk and its
  // offerings behind it, and his stand inside the box (Sam, 29 Oct: "the
  // shrine is in a funny place", "it's sort of in a weird corner by the cat
  // model's foot").
  center: [0, 0, 0],
  //leftShrine: [-20, 0, -10],
  //rightShrine: [20, 0, 10],
}

// Legacy - kept for reference but no longer rendered
export const PORTALS = []

// ===========================================
// TREES CONFIGURATION
// ===========================================
// Each tree entry defines a position and visual properties.
// All leaves within a tree clump share the same color.
export const TREES = [
  {
    id: 'ftree_1',
    position: [39.444, 0.0, 45.826],
    color: '#f08bff',
  },
  {
    id: 'ftree_2',
    position: [30.04, 0.0, 47.845],
    color: '#f08bff',
  },
  {
    id: 'ftree_3',
    position: [43.519, 0.0, 3.535],
    color: '#f08bff',
  },
  {
    id: 'ftree_4',
    position: [13.188, 0.0, -41.203],
    color: '#f08bff',
  },
  {
    id: 'ftree_5',
    position: [-19.745, 0.0, -16.455],
    color: '#f08bff',
  },
  {
    id: 'ftree_6',
    position: [-14.196, 0.0, -23.01],
    color: '#f08bff',
  },
  {
    id: 'ftree_7',
    position: [-33.66, 0.0, 9.09],
    color: '#f08bff',
  },
  {
    id: 'ftree_8',
    position: [-37.639, 0.0, 18.44],
    color: '#f08bff',
  },
  {
    id: 'ftree_9',
    position: [-34.406, 0.0, 28.278],
    color: '#f08bff',
  },
  {
    id: 'ftree_10',
    position: [-26.433, 0.0, 35.465],
    color: '#f08bff',
  },
  {
    id: 'ftree_11',
    position: [-15.94, 0.0, 33.613],
    color: '#f08bff',
  },
  {
    id: 'ftree_12',
    position: [-21.185, 0.0, 4.972],
    color: '#f08bff',
  },
  {
    id: 'ftree_13',
    position: [34.948, 0.0, -27.751],
    color: '#f08bff',
  },
  {
    id: 'ftree_14',
    position: [-47.985, 0.0, 46.763],
    color: '#f08bff',
  },
  {
    id: 'ftree_15',
    position: [19.426, 0.0, 51.179],
    color: '#f08bff',
  },
  {
    id: 'ftree_16',
    position: [95.943, 0.0, 0.987],
    color: '#f08bff',
  },
  {
    id: 'ftree_17',
    position: [51.806, 0.0, 3.406],
    color: '#f08bff',
  },
  {
    id: 'ftree_18',
    position: [98.966, 0.0, 12.777],
    color: '#f08bff',
  },
  {
    id: 'ftree_19',
    position: [37.296, 0.0, -45.87],
    color: '#f08bff',
  },
  {
    id: 'ftree_20',
    position: [27.622, 0.0, -52.823],
    color: '#f08bff',
  },
  {
    id: 'ftree_21',
    position: [1.624, 0.0, -70.659],
    color: '#f08bff',
  },
  {
    id: 'ftree_22',
    position: [16.285, 0.0, -80.333],
    color: '#f08bff',
  },
  {
    id: 'ftree_23',
    position: [12.96, 0.0, -71.263],
    color: '#f08bff',
  },
  {
    id: 'ftree_24',
    position: [-45.077, 0.0, 27.096],
    color: '#f08bff',
  },
  {
    id: 'ftree_25',
    position: [-52.535, 0.0, 30.359],
    color: '#f08bff',
  },
  {
    id: 'ftree_26',
    position: [-61.159, 0.0, 28.961],
    color: '#f08bff',
  },
  {
    id: 'ftree_27',
    position: [-88.83, 0.0, 41.334],
    color: '#f08bff',
  },
  {
    id: 'ftree_28',
    position: [-96.82, 0.0, 44.81],
    color: '#f08bff',
  },
  {
    id: 'ftree_29',
    position: [-84.7, 0.0, 48.772],
    color: '#f08bff',
  },
  {
    id: 'ftree_30',
    position: [-74.678, 0.0, 49.938],
    color: '#f08bff',
  },
  {
    id: 'ftree_31',
    position: [-80.039, 0.0, 38.051],
    color: '#f08bff',
  },
  // Sam's seven in the north-east, round the tube carriage and up the east
  // side (30 Oct): Sphere.031 to .037 in the blend's treePos collection
  {
    id: 'ftree_32',
    position: [81.182, 0.0, -79.266],
    color: '#f08bff',
  },
  {
    id: 'ftree_33',
    position: [82.894, 0.0, -92.325],
    color: '#f08bff',
  },
  {
    id: 'ftree_34',
    position: [103.66, 0.0, -83.12],
    color: '#f08bff',
  },
  {
    id: 'ftree_35',
    position: [98.522, 0.0, -70.917],
    color: '#f08bff',
  },
  {
    id: 'ftree_36',
    position: [95.525, 0.0, -50.58],
    color: '#f08bff',
  },
  {
    id: 'ftree_37',
    position: [97.666, 0.0, -19.752],
    color: '#f08bff',
  },
  {
    id: 'ftree_38',
    position: [94.883, 0.0, -92.967],
    color: '#f08bff',
  },
]

export const STREET_LIGHTS = [
  {
    id: 'streetLight_1',
    position: [31.173, 0.0, 20.555],
    rotation: [-0.0, -0.0, 0.0],
  },
  {
    id: 'streetLight_2',
    position: [28.903, 0.0, 40.367],
    rotation: [-0.0, 0.51, -0.0],
  },
  {
    id: 'streetLight_3',
    position: [-8.47, 0.0, 28.861],
    rotation: [-0.0, 3.809, -0.0],
  },
  {
    id: 'streetLight_4',
    position: [-26.932, 0.0, 8.47],
    rotation: [-0.0, 2.94, -0.0],
  },
  {
    id: 'streetLight_5',
    position: [-18.371, 0.0, -9.315],
    rotation: [-0.0, 2.391, -0.0],
  },
  {
    id: 'streetLight_6',
    position: [22.57, 0.0, -19.037],
    rotation: [-0.0, 0.636, -0.0],
  },
  {
    id: 'streetLight_7',
    position: [19.091, 0.0, -39.285],
    rotation: [-0.0, 1.315, -0.0],
  },
  {
    id: 'streetLight_8',
    position: [31.08, 0.0, 5.674],
    rotation: [-0.0, 0.233, -0.0],
  },
  {
    id: 'streetLight_9',
    position: [54.531, 0.0, 14.425],
    rotation: [-0.0, -0.0, 0.0],
  },
  {
    id: 'streetLight_10',
    position: [-32.416, 0.0, 22.181],
    rotation: [-0.0, 3.232, -0.0],
  },
  {
    id: 'streetLight_11',
    position: [68.457, -0.006, 1.323],
    rotation: [-0.0, 1.571, -0.0],
  },
  {
    id: 'streetLight_12',
    position: [93.807, -0.006, 12.68],
    rotation: [-0.0, -0.576, -0.0],
  },
  {
    id: 'streetLight_13',
    position: [-39.903, 0.0, 49.335],
    rotation: [-0.0, -1.54, -0.0],
  },
  {
    id: 'streetLight_14',
    position: [-3.789, 0.0, -57.05],
    rotation: [-0.0, 1.042, -0.0],
  },
  {
    id: 'streetLight_15',
    position: [46.621, 0.0, -19.153],
    rotation: [-0.0, -1.165, -0.0],
  },
  {
    id: 'streetLight_16',
    position: [33.947, 0.0, -39.952],
    rotation: [-0.0, -3.726, -0.0],
  },
  {
    id: 'streetLight_17',
    position: [47.621, 0.0, -60.339],
    rotation: [-0.0, -6.304, -0.0],
  },
  {
    id: 'streetLight_18',
    position: [2.666, 0.0, -83.358],
    rotation: [-0.0, 1.543, -0.0],
  },
  // Sam's eleven more (30 Oct), StreetLamp.019 to .029 in the blend: up the
  // east side, round the tube carriage and along the north and south edges.
  // Collision for each is a box in obstacles.glb (Cube.008 to .018)
  {
    id: 'streetLight_19',
    position: [25.975, 0.0, -59.521],
    rotation: [-0.0, 2.445, -0.0],
  },
  {
    id: 'streetLight_20',
    position: [48.96, 0.0, -81.683],
    rotation: [-0.0, 3.09, -0.0],
  },
  {
    id: 'streetLight_21',
    position: [73.866, 0.0, -76.04],
    rotation: [-0.0, 4.695, -0.0],
  },
  {
    id: 'streetLight_22',
    position: [81.028, 0.0, -87.596],
    rotation: [-0.0, 1.514, -0.0],
  },
  {
    id: 'streetLight_23',
    position: [94.117, 0.0, -68.278],
    rotation: [-0.0, -0.012, -0.0],
  },
  {
    id: 'streetLight_24',
    position: [87.026, 0.0, -31.698],
    rotation: [-0.0, -3.149, -0.0],
  },
  {
    id: 'streetLight_25',
    position: [96.176, 0.0, -14.373],
    rotation: [-0.0, -7.096, -0.0],
  },
  {
    id: 'streetLight_26',
    position: [113.118, 0.0, 28.973],
    rotation: [-0.0, -6.35, -0.0],
  },
  {
    id: 'streetLight_27',
    position: [94.047, 0.0, 33.245],
    rotation: [-0.0, -4.206, -0.0],
  },
  {
    id: 'streetLight_28',
    position: [72.976, 0.0, 52.816],
    rotation: [-0.0, -3.861, -0.0],
  },
  {
    id: 'streetLight_29',
    position: [48.553, 0.0, 40.124],
    rotation: [-0.0, -4.74, -0.0],
  },
]

export const BINS = [
  {
    id: 'bin_1',
    position: [31.061, 0.0, 4.146],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_2',
    position: [31.421, 0.0, 19.181],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_3',
    position: [-9.38, 0.0, 27.669],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_4',
    position: [-18.918, 0.0, -8.473],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_6',
    position: [15.022, 0.0, 51.826],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_7',
    position: [-39.821, 0.0, 48.701],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_8',
    position: [54.556, 0.0, 16.998],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_9',
    position: [93.943, 0.0, 11.999],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_10',
    position: [48.547, 0.0, -19.864],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_11',
    position: [35.239, 0.0, -38.349],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_12',
    position: [48.133, 0.0, -58.441],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_13',
    position: [19.756, 0.0, -82.986],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_14',
    position: [2.167, 0.0, -83.629],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_15',
    position: [-7.437, 0.0, -58.898],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'bin_16',
    position: [18.655, 0.0, -39.92],
    rotation: [0.0, -0.0, 0.0],
  },
]

export const BIN_BAGS = [
  {
    id: 'bin_bag_1',
    position: [33.958, 0.364, 7.033],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_2',
    position: [-17.621, 0.364, -8.822],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_3',
    position: [-17.524, 0.364, -8.041],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_4',
    position: [-8.376, 0.364, 27.64],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_5',
    position: [30.287, 0.364, 20.407],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_6',
    position: [30.423, 0.364, 21.346],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_7',
    position: [-10.046, 0.364, 26.944],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_8',
    position: [-9.246, 0.364, 26.91],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_10',
    position: [16.319, 0.364, 51.478],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_11',
    position: [16.416, 0.364, 52.258],
    rotation: [-0.011, -0.027, -0.142],
  },
  {
    id: 'bin_bag_12',
    position: [-41.126, 0.364, 49.019],
    rotation: [-0.011, -3.145, -0.142],
  },
  {
    id: 'bin_bag_13',
    position: [-41.205, 0.364, 48.236],
    rotation: [-0.011, -3.145, -0.142],
  },
  {
    id: 'bin_bag_14',
    position: [54.204, 0.364, 15.702],
    rotation: [-0.011, -1.6, -0.142],
  },
  {
    id: 'bin_bag_15',
    position: [54.985, 0.364, 15.602],
    rotation: [-0.011, -1.6, -0.142],
  },
  {
    id: 'bin_bag_16',
    position: [93.513, 0.364, 13.271],
    rotation: [-0.011, 2.132, -0.142],
  },
  {
    id: 'bin_bag_17',
    position: [92.81, 0.364, 12.919],
    rotation: [-0.011, 2.132, -0.142],
  },
  {
    id: 'bin_bag_18',
    position: [47.253, 0.364, -19.506],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_19',
    position: [47.149, 0.364, -20.285],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_20',
    position: [33.945, 0.364, -37.991],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_21',
    position: [33.842, 0.364, -38.771],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_22',
    position: [46.839, 0.364, -58.083],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_23',
    position: [46.736, 0.364, -58.862],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_24',
    position: [18.462, 0.364, -82.628],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_25',
    position: [18.359, 0.364, -83.408],
    rotation: [-0.011, 3.107, -0.142],
  },
  {
    id: 'bin_bag_26',
    position: [3.127, 0.364, -82.69],
    rotation: [-0.011, 1.01, -0.142],
  },
  {
    id: 'bin_bag_27',
    position: [2.505, 0.364, -82.209],
    rotation: [-0.011, 1.01, -0.142],
  },
  {
    id: 'bin_bag_28',
    position: [-7.152, 0.364, -57.586],
    rotation: [-0.011, 1.592, -0.142],
  },
  {
    id: 'bin_bag_29',
    position: [-7.936, 0.364, -57.526],
    rotation: [-0.011, 1.592, -0.142],
  },
  {
    id: 'bin_bag_30',
    position: [18.94, 0.364, -38.607],
    rotation: [-0.011, 1.592, -0.142],
  },
  {
    id: 'bin_bag_31',
    position: [18.156, 0.364, -38.548],
    rotation: [-0.011, 1.592, -0.142],
  },
]

// Origins fixed at source (Blender) to each dumpster's base-centre, so these
// are the true positions + clean Y rotations (see Rubbish.jsx).
export const DUMPSTER = [
  {
    id: 'dumpster_1',
    position: [31.963, -0.001, -36.353],
    rotation: [0.0, -0.59, -0.0],
  },
  {
    id: 'dumpster_2',
    position: [50.986, -0.001, 35.71],
    rotation: [0.0, 0.0, 0.0],
  },
  {
    id: 'dumpster_3',
    position: [11.851, -0.001, 60.11],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'dumpster_4',
    position: [53.43, -0.001, -16.28],
    rotation: [0.0, 3.14, 0.0],
  },
  {
    id: 'dumpster_5',
    position: [53.43, -0.001, -12.737],
    rotation: [0.0, 3.14, 0.0],
  },
  {
    id: 'dumpster_6',
    position: [-7.2, -0.001, -61.32],
    rotation: [0.0, -0.0, 0.0],
  },
  {
    id: 'dumpster_7',
    position: [19.049, -0.001, -76.127],
    rotation: [0.0, 3.14, 0.0],
  },
  {
    id: 'dumpster_8',
    position: [19.049, -0.001, -72.393],
    rotation: [0.0, 3.14, 0.0],
  },
]

// Wire-fence panels — one shared fence.glb panel, GPU-instanced at these
// transforms (see components/three/world/Fences.jsx). rotation is Euler radians.
export const FENCES = [
  {
    id: 'fence_1',
    position: [-44.088, 1.688, 50.431],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_2',
    position: [-44.088, 1.688, 53.931],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_3',
    position: [-44.088, 1.688, 57.431],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_4',
    position: [-44.088, 1.688, 60.931],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_5',
    position: [-44.088, 1.688, 64.431],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_6',
    position: [-44.088, 1.688, 67.931],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_7',
    position: [-16.057, 1.688, -18.749],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_8',
    position: [-16.057, 1.688, -15.249],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_9',
    position: [-16.057, 1.688, -11.749],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_10',
    position: [-16.057, 1.688, -8.249],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_11',
    position: [-16.057, 1.688, -4.749],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_12',
    position: [-16.057, 1.688, -1.249],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_13',
    position: [-17.807, 1.688, -20.499],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_14',
    position: [-21.307, 1.688, -20.499],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_15',
    position: [-24.807, 1.688, -20.499],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_16',
    position: [56.353, 1.688, 34.261],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_17',
    position: [56.353, 1.688, 37.761],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_18',
    position: [56.353, 1.688, 41.261],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_19',
    position: [56.353, 1.688, 44.761],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_20',
    position: [56.353, 1.688, 48.261],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_21',
    position: [19.154, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_22',
    position: [15.654, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_23',
    position: [12.154, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_24',
    position: [8.654, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_25',
    position: [5.154, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_26',
    position: [1.654, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_27',
    position: [-1.846, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_28',
    position: [-5.346, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_29',
    position: [-8.846, 1.688, -84.334],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_30',
    position: [15.973, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_31',
    position: [19.473, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_32',
    position: [22.973, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_33',
    position: [26.473, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_34',
    position: [29.973, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_35',
    position: [33.473, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_36',
    position: [36.973, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_37',
    position: [40.473, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_38',
    position: [43.973, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_39',
    position: [47.473, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_40',
    position: [50.973, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_41',
    position: [54.473, 1.688, 53.633],
    rotation: [-0.0, -3.142, -0.0],
  },
  {
    id: 'fence_42',
    position: [56.353, 1.688, 51.761],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_43',
    position: [-107.386, 1.688, 36.186],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_44',
    position: [-107.386, 1.688, 39.686],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_45',
    position: [-107.386, 1.688, 43.186],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_46',
    position: [-107.386, 1.688, 46.686],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_47',
    position: [-107.386, 1.688, 50.186],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_48',
    position: [-109.032, 1.688, 52.177],
    rotation: [-0.0, -0.0, -0.0],
  },
  {
    id: 'fence_49',
    position: [-112.532, 1.688, 52.177],
    rotation: [-0.0, -0.0, -0.0],
  },
  {
    id: 'fence_50',
    position: [113.684, 1.688, 23.587],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_51',
    position: [113.684, 1.688, 27.087],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_52',
    position: [113.684, 1.688, 30.587],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_53',
    position: [113.684, 1.688, 34.087],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_54',
    position: [113.684, 1.688, 37.587],
    rotation: [-0.0, -1.571, -0.0],
  },
  {
    id: 'fence_55',
    position: [113.684, 1.688, 41.087],
    rotation: [-0.0, -1.571, -0.0],
  },
]

export const POINTS_OF_INTEREST = [
  {
    id: 'poi_1',
    name: 'drinkAlcohol',
    position: [79.305, 0.0, 1.463],
  },
  {
    id: 'poi_2',
    name: 'drinkCoffee',
    position: [30.022, 0.0, 11.608],
  },
  {
    id: 'poi_3',
    name: 'eatChinese',
    position: [10.013, 0.0, -47.888],
  },
  {
    id: 'poi_4',
    name: 'eatChinese_2',
    position: [-16.938, 0.0, 47.927],
  },
  {
    id: 'poi_5',
    name: 'eatHealth',
    position: [-18.61, 0.0, 7.25],
  },
  {
    id: 'poi_6',
    name: 'eatJunk',
    position: [25.565, 0.0, -5.527],
  },
  {
    id: 'poi_7',
    name: 'gamble',
    position: [33.192, 0.0, 27.357],
  },
  {
    id: 'poi_8',
    name: 'laundry',
    // inside the laundrette's own building past the monorail, between the island of washers and the benches under
    // the window, where he watches the drums (3 Nov: the old laundrette front at 46.6, -23.6 closed "due to
    // relocation" on 12 Oct, and this is where it went). The actions button is ten metres round this.
    position: [67.57, 0.0, -97.15],
  },
  {
    id: 'poi_9',
    name: 'museum',
    position: [-14.454, 0.0, -54.52],
  },
  {
    id: 'poi_10',
    name: 'phone',
    position: [-26.256, 0.0, 47.694],
  },
  {
    id: 'poi_11',
    name: 'pond',
    position: [-71.038, 0.0, 27.502],
  },
  {
    // The green stone Pino asked the octopus for. Tracks the baked
    // position of the stone mesh inside public/models/greenStone.glb, so
    // the resonance field is centred on the rock rather than near it.
    // MOVED 2026-08-18 when the stone gained its ruins: re-check this
    // against the GLB's Icosphere node on every re-export.
    id: 'poi_greenstone',
    name: 'greenStone',
    position: [-86.30, 0.0, 26.65],
  },
  {
    // The meadow the octopus was asked for. NOT a number anybody chose:
    // the grass grows on red vertex colours painted into terrain.glb, and
    // this is the centroid of that paint, read off the running scatter
    // (world/Meadow.jsx logs it). Repaint the mask somewhere else and this
    // has to be re-read, because the sim cannot decompress the terrain to
    // work it out for itself.
    id: 'poi_meadow',
    name: 'meadow',
    position: [-100.18, 0.0, 46.62],
  },
  {
    id: 'poi_12',
    name: 'rave',
    position: [-22.373, 0.0, 20.126],
  },
  // (the first roost, 'rest', was poi_13; it comes off the blend with the others now: MODEL_POIS below)
  {
    id: 'poi_14',
    name: 'salon',
    position: [58.649, 0.0, 1.463],
  },
  {
    id: 'poi_15',
    name: 'shrine',
    // Shrine + its glowing floor circle live here (SHRINES.center).
    position: [0.0, 0.0, 0.0],
  },
  {
    id: 'poi_shrine_stand',
    name: 'shrine_stand',
    // The model itself is a collision volume. This point is the clear piece
    // of paving in front of it where an inspection can actually complete:
    // on the cat's line, facing it, 2.5 clear of the front of its box (z 3.02)
    // and so of its paws and the offerings at its feet.
    position: [0.0, 0.0, 5.5],
  },
  {
    id: 'poi_16',
    name: 'surfInternet',
    position: [23.089, 0.0, -34.548],
  },
  {
    id: 'poi_17',
    name: 'tattoo',
    position: [1.26, 0.0, -54.268],
  },
  {
    id: 'poi_18',
    name: 'watchMovie',
    position: [4.999, 0.0, 47.767],
  },
  // (the nest roosts, rest_2 to rest_5, are in MODEL_POIS too)
  {
    id: 'poi_22',
    name: 'artWall',
    position: [-77.853, 0.0, 55.065],
  },
  {
    id: 'poi_23',
    name: 'studio',
    position: [-58.167, 0.0, 48.862],
  },
  {
    id: 'poi_24',
    name: 'poster_bar',
    position: [78.507, 0.0, 1.733],
  },
  {
    id: 'poi_25',
    name: 'poster_cinema',
    position: [16.018, 0.907, 56.277],
  },
  {
    id: 'poi_26',
    name: 'poster_museum',
    position: [-15.536, 0.0, -52.313],
  },
  {
    id: 'poi_27',
    name: 'poster_rave',
    position: [-30.041, 0.0, -0.837],
  },
  {
    id: 'poi_28',
    name: 'green_stone',
    position: [-80.19, 0.0, 26.867],
  },
  {
    id: 'poi_29',
    name: 'pond_paddle',
    position: [-75.655, 0.0, 20.291],
  },
  {
    id: 'poi_30',
    name: 'eatMushroom_1',
    position: [94.286, 0.0, -2.346],
  },
  {
    id: 'poi_31',
    name: 'eatMushroom_2',
    position: [-85.41, 0.0, 34.972],
  },
  {
    id: 'poi_32',
    name: 'eatMushroom_3',
    position: [15.187, 0.0, -68.87],
  },
  {
    id: 'poi_33',
    name: 'eatMushroom_4',
    position: [52.776, 0.0, 29.834],
  },
  {
    id: 'poi_34',
    name: 'tagging_01',
    position: [69.514, 0.0, 34.701],
  },
  {
    id: 'poi_35',
    name: 'tagging_02',
    position: [69.514, 0.0, 56.387],
  },
  {
    id: 'poi_36',
    name: 'tagging_03',
    position: [-52.284, 0.0, 56.387],
  },
  {
    id: 'poi_37',
    name: 'tagging_04',
    position: [53.409, 0.0, -6.365],
  },
  {
    id: 'poi_38',
    name: 'tagging_05',
    position: [33.189, 0.0, -46.824],
  },
  {
    id: 'poi_39',
    name: 'tagging_06',
    position: [-6.081, 0.0, -68.987],
  },
  // two more walls (Sam, 2 Nov: "lets add a couple more walls he can spray on in the world - over by the west side by
  // his train carriage roost and another somewhere else"): the community workshop's north end, across the open ground
  // from the carriage's door, and a wall of its own behind the rave's speakers. where he stands, 2.6 to 2.8 m in front
  {
    id: 'poi_52',
    name: 'tagging_08',
    position: [79.14, 0.0, -76.5],
  },
  {
    id: 'poi_53',
    name: 'tagging_09',
    position: [-27.952, 0.0, 22.423],
  },
  {
    id: 'poi_40',
    name: 'playPiano',
    position: [21.834, 0.0, -50.741],
  },
  {
    id: 'poi_41',
    name: 'eatBakery',
    position: [-9.35, 0.0, 48.586],
  },
  {
    id: 'poi_42',
    name: 'eatPizza',
    position: [88.591, 0.0, 2.321],
  },
  // The town clock, at the far end of the east street, past the pizza
  // place and the mushrooms, near the edge of the map. Sam's pick: the
  // street already runs salon -> bar -> pizza and dead-ends there, so a
  // clock at the vanishing point gives him a reason to walk the whole
  // length of it rather than turning back at the bar.
  {
    id: 'poi_43',
    name: 'windClock',
    position: [111.2, 0.0, 5.9],
  },
  {
    id: 'poi_44',
    name: 'activity3DPrinters',
    position: [101.969, 0.0, 18.876],
  },
  // The greenhouse, by the meadow's west edge (the meadow is centred
  // near -104.7, 50.4 with a radius of ~21; this sits just outside the
  // grass). Move it here and the sim's entity, the walker's doorstep and
  // the placeholder all move with it.
  // Moved 14 Sep to meet Sam's model: the allotment he built runs from
  // about x -113 to -94 and z 36 to 73 (two greenhouses, three raised
  // beds). This is his doorstep, in the open middle of it with the beds
  // to the east and both greenhouses to the north and west.
  //
  // CHECKED AGAINST obstacles.glb, and it had to be: the obvious spot by
  // the watering can sits inside the glass greenhouse's blocker once the
  // nav grid inflates it (cells are about 1.3u), so he could have wanted
  // to tend and never been able to path to his own garden. Three units
  // of clearance here. Re-check if the blockers move.
  {
    id: 'poi_garden',
    name: 'garden',
    position: [-100.0, 0.0, 52.0],
  },
  // The street running south from the pizza place, Sam's, 7 Oct: a row
  // facing east (the japanese restaurant, City Mags, the community
  // workshop at the far end) and a row facing west across it (the
  // community art gallery, the early bakery, the tech shop). Each spot is
  // on the pavement in front of the door, clear of the building's box in
  // obstacles.glb by more than the nav grid's inflation, so the walk ends
  // where the door is.
  {
    id: 'poi_45',
    name: 'eatJapanese',
    position: [84.6, 0.0, -35.5],
  },
  {
    id: 'poi_46',
    name: 'eatBakeryEarly',
    position: [94.4, 0.0, -38.5],
  },
  {
    id: 'poi_47',
    name: 'shopMags',
    position: [84.5, 0.0, -43.6],
  },
  {
    id: 'poi_48',
    name: 'shopGallery',
    position: [95.6, 0.0, -29.9],
  },
  {
    id: 'poi_49',
    name: 'shopWorkshop',
    position: [86.0, 0.0, -65.2],
  },
  {
    id: 'poi_50',
    name: 'shopTech',
    position: [94.5, 0.0, -60.7],
  },
  // The job centre (sim-server world/JobCentre.js; Sam, 30 Oct: "instead of the tech store, can we make it the currently
  // selected building in Blender"): buildings_25, between City Mags and the community workshop on the row facing east,
  // its shutters covered by its own front in jobCentre.glb. On the pavement before the middle of the opening, 1.7 m
  // clear of obs_buildings_25 (x up to 84.42 in the blend).
  {
    id: 'poi_job_centre',
    name: 'jobCentre',
    position: [86.1, 0.0, -52.1],
  },
  // The taco truck against the long tagged wall on the east side, beside
  // the soup cart: in front of its stools, the counter's food on the
  // ground here like every other counter's.
  {
    id: 'poi_51',
    name: 'eatTaco',
    position: [88.0, 0.0, 36.6],
  },





]

// The POIs that belong to a model: where he stands at each want he uses
// (the soup cart, the shelter, the bench, the keys, the night market, the
// fresh wall) and at the rack. They come off the models' own stand empties in Kiwi_world.blend
// (lib/world/modelPois.js, scripts/blender/wants-sync.py), so a model moved
// there brings its spot with it instead of leaving him at the old one.
// His roosts come off the blend the same way: rest to rest_4 inside the
// four open containers, rest_5 inside the tube carriage (Sam, 30 Oct: "I
// want Pino to be able to go inside"). They stood at the containers' mouths
// until then; obstacles.glb has walls with an opening where they had a box.
POINTS_OF_INTEREST.push(...MODEL_POIS)

/** The nest roosts: every POI that is a rest point (rest, rest_2 ... rest_5). */
export function restPoints() {
  return POINTS_OF_INTEREST.filter((p) => p.name === 'rest' || p.name.startsWith('rest_'))
}


// ===========================================
// THE TOWN — placeholder build-out (2026-07-02)
// ===========================================
// Data-driven town layout so the world reads as a PLACE: districts, homes,
// shops, landmarks, clutter. Rendered by PlaceholderTown.jsx as flat-shaded
// primitives; replace kinds with real assets 1:1 (each entry keeps its id).
// Blocking buildings are axis-aligned (rotY multiples of 90°) so their
// AABBs feed the sim's collision via townObstacleAABBs().
//
// Districts:
//   • Market square  — stalls + benches around the shrine
//   • High street    — shops filling the food/casino strip (east)
//   • West rows      — houses near the rave + apple tree
//   • North village  — cottages + the hall by the cinema
//   • South docks    — warehouse/crates near internet cafe + junk heap
//   • Landmarks      — water tower (NE), radio mast (W), greenhouse (SW)

export const TOWN = {
  buildings: [
    // ── High street (east strip, facing west toward x≈20) ──
    { id: 'shop_bakery', kind: 'shop', position: [29.5, 0, 2.0], rotY: 270, size: [5, 3.4, 4.5], color: '#d9a066', label: 'bakery' },
    { id: 'shop_laundry', kind: 'shop', position: [31.5, 0, -10.5], rotY: 270, size: [5.5, 3.2, 4.5], color: '#8fb8c9', label: 'laundrette' },
    { id: 'shop_arcade', kind: 'shop', position: [28.0, 0, 19.5], rotY: 270, size: [5, 3.8, 5], color: '#b085d1', label: 'arcade' },
    { id: 'shop_corner', kind: 'shop', position: [36.5, 0, 7.5], rotY: 270, size: [4.5, 3.2, 4.5], color: '#c9788a', label: 'corner shop' },
    { id: 'flats_high', kind: 'tower', position: [40.0, 0, -3.0], rotY: 0, size: [6, 12, 6], color: '#9a8fa8' },
    // ── West rows (residential) ──
    { id: 'house_w1', kind: 'house', position: [-33.5, 0, 0.5], rotY: 90, size: [4.5, 3, 4], color: '#cbb7de' },
    { id: 'house_w2', kind: 'house', position: [-38.5, 0, 6.0], rotY: 90, size: [4, 2.8, 4], color: '#dbc3a3' },
    { id: 'house_w3', kind: 'house', position: [-34.0, 0, 12.0], rotY: 90, size: [4.5, 3.2, 4], color: '#a8c4b2' },
    { id: 'house_w4', kind: 'house', position: [-41.0, 0, -3.5], rotY: 0, size: [4, 2.8, 4.5], color: '#c9a3a3' },
    // ── North village (by the cinema) ──
    { id: 'house_n1', kind: 'house', position: [-1.5, 0, 41.0], rotY: 180, size: [4.5, 3, 4], color: '#b9a3c9' },
    { id: 'house_n2', kind: 'house', position: [-9.0, 0, 37.0], rotY: 180, size: [4, 2.8, 4], color: '#d1b7a0' },
    { id: 'house_n3', kind: 'house', position: [4.5, 0, 45.5], rotY: 180, size: [4, 3, 4], color: '#a3b7c9' },
    { id: 'town_hall', kind: 'hall', position: [-16.5, 0, 43.0], rotY: 180, size: [8, 5, 6], color: '#c4bdb2', label: 'the hall' },
    // ── South docks (near internet cafe + junk heap) ──
    { id: 'warehouse_s', kind: 'hall', position: [40.0, 0, -27.0], rotY: 0, size: [9, 4.5, 7], color: '#8a94a3' },
    { id: 'fishing_hut', kind: 'house', position: [6.5, 0, -35.0], rotY: 0, size: [3.5, 2.4, 3], color: '#7f9c96' },
    // ── Landmarks ──
    { id: 'greenhouse_sw', kind: 'greenhouse', position: [-41.5, 0, -13.0], rotY: 0, size: [5, 3, 4], color: '#bfe3d2' },
  ],
  props: [
    // Market square around the shrine (shrine at ~[4.6, 8.4])
    { id: 'stall_1', kind: 'stall', position: [10.5, 0, 4.5], rotY: 300, color: '#d1798a' },
    { id: 'stall_2', kind: 'stall', position: [11.5, 0, 11.5], rotY: 260, color: '#7aa3d1' },
    { id: 'stall_3', kind: 'stall', position: [7.5, 0, 15.5], rotY: 220, color: '#d1c47a' },
    { id: 'bench_sq1', kind: 'bench', position: [1.0, 0, 14.0], rotY: 145 },
    { id: 'bench_sq2', kind: 'bench', position: [-1.5, 0, 3.5], rotY: 30 },
    { id: 'planter_1', kind: 'planter', position: [0.5, 0, 18.0], rotY: 0 },
    { id: 'noticeboard', kind: 'board', position: [8.0, 0, 1.0], rotY: 320 },
    // High street clutter
    { id: 'busstop', kind: 'busstop', position: [22.5, 0, 6.0], rotY: 90 },
    { id: 'postbox', kind: 'postbox', position: [23.5, 0, 12.5], rotY: 0 },
    { id: 'phonebox', kind: 'phonebox', position: [25.5, 0, -30.0], rotY: 45 },
    // parked until it has real textures; bare boards read as broken
    // { id: 'billboard', kind: 'billboard', position: [34.0, 0, 14.0], rotY: 250 },
    // West rows clutter
    { id: 'fence_w1', kind: 'fence', position: [-36.5, 0, 3.2], rotY: 90, span: 9 },
    { id: 'laundry_w', kind: 'laundryline', position: [-36.0, 0, 9.0], rotY: 20 },
    { id: 'bench_w', kind: 'bench', position: [-28.5, 0, 9.5], rotY: 265 },
    // North village clutter
    { id: 'fence_n1', kind: 'fence', position: [-5.0, 0, 39.5], rotY: 45, span: 7 },
    { id: 'planter_n', kind: 'planter', position: [2.0, 0, 40.5], rotY: 0 },
    // South docks clutter
    { id: 'crates_s1', kind: 'crates', position: [36.0, 0, -22.5], rotY: 30 },
    { id: 'crates_s2', kind: 'crates', position: [43.5, 0, -31.5], rotY: 70 },
    { id: 'barrels_s', kind: 'barrels', position: [12.0, 0, -33.0], rotY: 0 },
    { id: 'bench_pond', kind: 'bench', position: [-6.5, 0, -25.0], rotY: 115 },
    { id: 'bench_pond2', kind: 'bench', position: [2.5, 0, -24.0], rotY: 245 },
    // Landmarks
    { id: 'watertower', kind: 'watertower', position: [48.0, 0, 28.0], rotY: 0 },
    { id: 'radiomast', kind: 'radiomast', position: [-46.0, 0, 20.0], rotY: 0 },
  ],
}

/**
 * Axis-aligned collision AABBs for the town's BLOCKING structures, in the
 * same {minX,maxX,minZ,maxZ} shape the sim's ServerObstacles expects.
 * Buildings block; big landmarks block; small props don't (the bird weaves
 * through clutter). rotY 90/270 swaps footprint width/depth.
 */
export function townObstacleAABBs() {
  const aabbs = []
  for (const b of TOWN.buildings) {
    const [w, , d] = b.size
    const swap = b.rotY % 180 !== 0
    const halfW = (swap ? d : w) / 2
    const halfD = (swap ? w : d) / 2
    aabbs.push({
      minX: b.position[0] - halfW,
      maxX: b.position[0] + halfW,
      minZ: b.position[2] - halfD,
      maxZ: b.position[2] + halfD,
    })
  }
  for (const p of TOWN.props) {
    if (p.kind === 'watertower' || p.kind === 'radiomast') {
      aabbs.push({
        minX: p.position[0] - 1.6, maxX: p.position[0] + 1.6,
        minZ: p.position[2] - 1.6, maxZ: p.position[2] + 1.6,
      })
    }
  }
  return aabbs
}

// Default tree settings (can be overridden per-tree in the future)
export const TREE_DEFAULTS = {
  clusterCount: 8,
  clusterRadius: 2.25,
  leafSpread: 1.8,
  leafScale: 0.5,
  foldStrength: 0.5,
  curveStrength: 1.22,
  curveTopBoost: 0.34,
  leafTilt: 0.48,
  leafTiltVariance: 0.0,
  alphaThreshold: 0.5,
}

// ===========================================
// ARTIFACT CATALOG
// ===========================================
// Data-driven list of artifacts placed in the world.
// Each entry creates an ARTIFACT entity in the sim-server.
// The shrine is the first artifact — later: community votes to add/swap artifacts.
export const ARTIFACT_CATALOG = [
  {
    id: 'artifact_shrine',
    name: 'The Cat Shrine',
    poiName: 'shrine',       // maps to a POINTS_OF_INTEREST entry for position
    standAt: 'shrine_stand', // interaction point outside the shrine collision box
    resonanceEmission: 0.75, // peak resonance strength when active (0-1)
    awePower: 0.80,          // multiplier on mood effects while artifact is active
    toggleMin: 120,          // min seconds before resonance state flips
    toggleMax: 300,          // max seconds before resonance state flips
    radius: 15,              // how far the field reaches
    tint: 'violet',          // viewer picks the disk colour off this
    feeds: 'curiosity',      // standing in it tops up wonder
  },
  {
    // GRANTED. On 2026-08-17 he spent a wish on "a small glowing stone to
    // appear by the pond, a sign that I'm not alone", and Sam granted it.
    //
    // It feeds SOCIAL, not curiosity, and that is the whole point: he did
    // not ask to be amazed, he asked not to be alone, so the thing answers
    // loneliness. It also keeps the stone clear of the wonder-chasing loop
    // that produced every fixation he has ever had (beetles, the hum, the
    // glow), which matters more than usual here because "glowing" already
    // appears seven times in his long-term memory.
    //
    // Smaller and dimmer than the shrine on purpose. It is a stone at the
    // water's edge, not a monument, and it should never out-shout the
    // place it sits in.
    id: 'artifact_greenstone',
    name: 'The Green Stone',
    // Two positions, because they answer two questions. poiName is the
    // rock itself (tracked to the GLB's mesh, which is what the resonance
    // field has to be centred on) and standAt is the bit of bank to stand
    // on, placed by hand. Walking to the first means walking into a
    // boulder inside a ruin.
    poiName: 'greenStone',
    standAt: 'green_stone',
    resonanceEmission: 0.55,
    awePower: 0.45,
    // Its own rhythm, slower and less regular than the shrine's, so the
    // two are never in step and neither reads as a machine.
    // toggleMin/Max are inert for this one: the green stone's resonance is
    // driven by real viewers, not a timer (see Entities.updateArtifact).
    toggleMin: 200,
    toggleMax: 520,
    // Wider than the shrine's reach. The stone sits inside a 10u structure,
    // so a 9u field barely cleared the masonry and read as a scuff on the
    // floor; 15 still stopped at the ruins' edge. This spills well out onto
    // the paving and the bank, which is the point: the light should reach
    // him before the rock does.
    radius: 24,
    tint: 'green',
    feeds: 'social',
  },
]

// Community voting hook — placeholder for future API integration.
// Future: POST vote to backend, trigger community tally, cycle active artifact.
export function voteForArtifact(artifactId) {
  console.log(`[Artifacts] Community vote registered for: ${artifactId}`)
}

// Manual toggle: is music playing in the world right now?
// The rave spot only gives euphoria when this is true.
// Later: replace with live IRL music-stream detection.
export const MUSIC_PLAYING = false

// Wind settings for the instanced leaves shader
export const TREE_WIND = {
  swayX: 0.15,
  swayY: 0.08,
  swayZ: 0.15,
  bendStrength: 0.35,
  rippleStrength: 0.08,
  wholeSway: 0.12,
}
